import BlueButton from 'client/components/core/BlueButton'
import { Dialog, DialogBody, DialogHeader } from 'client/components/core/Dialog'
import copyToClipboard from 'common/utils/copyToClipboard'
import React, { useState } from 'react'
import { useTypedTranslation } from 'src/shared/i18next/hooks/use-typed-translation'
import { BlockType } from '../types'

interface BlockShareDialogProps {
  block: BlockType
  close: () => void
}

export const BlockShareDialog = ({ block, close }: BlockShareDialogProps) => {
  const { t } = useTypedTranslation()
  const [isCopied, setCopied] = useState(false)
  const shareUrl = `${process.env.SYSTEME_IO_HOST}/dashboard/share?hash=${block.hash}&type=${
    block.isMaster ? 'master-block' : 'user-block'
  }`

  const handleCopy = () => {
    copyToClipboard(shareUrl)
    setCopied(true)
    setTimeout(close, 1500)
  }

  return (
    <Dialog show close={close} small>
      <DialogHeader close={close} center grayHeader={false}>
        <h2>{t('components.core.blocks_library.share_dialog.title')}</h2>
      </DialogHeader>
      <DialogBody small center>
        <p>{t('components.core.blocks_library.share_dialog.description')}</p>
        <div className="my-4 rounded-sm border border-border200 border-solid bg-iconTertiary p-2 text-S">
          {shareUrl}
        </div>
        <BlueButton onClick={handleCopy}>
          {t('components.core.blocks_library.share_dialog.copy_button.text')}
        </BlueButton>
        {isCopied && (
          <p>
            <small className="text-iconSuccess">
              {t('components.core.blocks_library.share_dialog.is_copied')}
            </small>
          </p>
        )}
      </DialogBody>
    </Dialog>
  )
}
